import Error403 from './Error403.component'

export default Error403
